const replaceSubmitButton = () => {
    if (document.querySelector('input#wp-submit')) {

        const oldBtn = document.querySelector('input#wp-submit');
        const oldAttributes = oldBtn.attributes;
        const newBtn = document.createElement('button');
        oldAttributes.forEach(att => {
            newBtn.setAttribute(att.nodeName, att.nodeValue);
        })
        newBtn.innerHTML = oldBtn.getAttribute('value');
        oldBtn.parentNode.replaceChild(newBtn, oldBtn);

    }
}
export default replaceSubmitButton;